import { connect } from 'react-redux';

import { ShowContactsLayout, IShowContactsLayoutStateProps } from '.';
import { IState } from '../../../store';
import { MODERATION_STATUS_TYPES } from '../../../types';

function mapStateToProps(state: IState): IShowContactsLayoutStateProps {
  const {
    villageData: {
      village: { builder },
    },
  } = state;

  return {
    phone:
      builder && builder.moderationStatus === MODERATION_STATUS_TYPES.Published && builder.displayPhone
        ? builder.phone
        : '',
  };
}

export const ShowContactsLayoutContainer = connect<IShowContactsLayoutStateProps>(mapStateToProps)(ShowContactsLayout);
